import {Dispatch, Middleware, MiddlewareAPI} from "redux";

export function createAxiosAuthMiddleware() {
    const authMiddleware: Middleware = ({ getState }: MiddlewareAPI) => (
        next: Dispatch
    ) => action => {
        const  state = getState()
        return next(action)
    }

    return authMiddleware
}